<form [formGroup]="eventSourceForm" novalidate>
  <div class="modal-header">
    <h1>{{title}}</h1>
  </div>
  <div class="modal-body">
    <div class="alert alert-danger alert-dismissable" *ngIf="errorMsg">
      {{errorMsg}}
      <a (click)="clearErrorMessage()">
        <span class="float-right close-button">
          <fa-icon [icon]="faTimes"></fa-icon>
        </span>
      </a>
    </div>
    <div class="form-group">
      <label>Code</label>
      <input type="text" class="form-control" formControlName="code">
      <div class="mt-2" [hidden]="eventSourceForm.controls.code.valid">
        <small class="text-danger">Input a Code</small>
      </div>
    </div>
    <div class="form-group">
      <label>Description</label>
      <input type="text" class="form-control" formControlName="description">
    </div>
  <div class="modal-footer">
    <button class="btn btn-dark-blue" type="submit" [disabled]="!eventSourceForm.valid" (click)="ok()" title="Save">
      <fa-icon [icon]="faSave"></fa-icon>
    </button>
    <button class="btn btn-attention" type="button" (click)="cancel()" title="Cancel">
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
  </div>
</div>
</form>
